/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Bulk_Delete_Artifacts_SuccessInputs */



/**
* | output |
* | --- |
* | "{count} artifact(s) deleted successfully." |
*
* @param {Bulk_Delete_Artifacts_SuccessInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const bulk_delete_artifacts_success = /** @type {((inputs: Bulk_Delete_Artifacts_SuccessInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bulk_Delete_Artifacts_SuccessInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.count} Artefakt(e) erfolgreich gelöscht.`)
	return /** @type {LocalizedString} */ (`${i?.count} artifact(s) deleted successfully.`)
});